<script setup>
import { computed, inject, onMounted, ref } from "vue";

const props = defineProps({
  isActive: {
    type: Boolean,
    required: false,
    default: false
  }
});

const Accordion = inject("Accordion");
const index = ref(null);
const isInitialLoad = ref(false);

onMounted(() => {
  index.value = Accordion.count++;
  isInitialLoad.value = true;

  if (props.isActive) {
    Accordion.active = index.value;
  }
});

const visible = computed(() => Accordion.expanded || index.value === Accordion.active);

function open() {
  Accordion.active = visible.value ? null : index.value;
}
</script>

<template>
  <li v-if="isInitialLoad">
    <div>
      <slot name="trigger" :open="open" :is-active="visible" />
    </div>

    <div v-show="visible">
      <slot />
    </div>
  </li>
</template>
